(function () {
    const blocksContainer = document.querySelector('.category-media-text__blocks');
    const progressBar = document.querySelector('.category-media-text__progress-bar');

    if (!blocksContainer || !progressBar) return;

    function updateProgress() {
        const scrollLeft = blocksContainer.scrollLeft;
        const scrollWidth = blocksContainer.scrollWidth;
        const clientWidth = blocksContainer.clientWidth;
        const maxScroll = scrollWidth - clientWidth;

        if (maxScroll <= 0) {
            progressBar.style.width = '100%';
            return;
        }

        if (scrollLeft + clientWidth >= scrollWidth - 1) {
            progressBar.style.width = '100%';
            return;
        }

        if (scrollLeft === 0) {
            progressBar.style.width = '8%';
            return;
        }

        const progress = (scrollLeft / maxScroll) * 100;
        progressBar.style.width = progress + '%';
    }

    blocksContainer.addEventListener('scroll', updateProgress);
    window.addEventListener('resize', updateProgress);
    updateProgress();
})();